import React from 'react';
import { CircleGauge } from 'lucide-react';
import { useAppSelector } from 'src/store';
import { getAppRoutesAvailability, getPortfolioRoutesAvailability } from 'src/routes/state/routesSelector';
import { useLocation } from 'react-router-dom';
import useAppNavigation from 'src/shared/hooks/useAppNavigation';
import { useIsWithheldFromUser, useIsSetToHidden } from 'src/shared/hooks/useProductLicensing';
import { ProductKey } from 'src/shared/types/engine/products';
import NestedSidebarMenuItem, { NestedSidebarMenuLeafItem } from './NestedSidebarMenuItem';

const GlobalNaturePerformanceMenu = () => {
    const appRoutesAvailability = useAppSelector(getAppRoutesAvailability);
    const portfolioRoutesAvailability = useAppSelector(getPortfolioRoutesAvailability);
    const navigate = useAppNavigation();
    const { pathname } = useLocation();
    const isWithheld = useIsWithheldFromUser(ProductKey.GLOBAL_NATURE_PERFORMANCE);
    const isSetToHidden = useIsSetToHidden(ProductKey.GLOBAL_NATURE_PERFORMANCE);

    if (!appRoutesAvailability.portfolio || isWithheld) {
        return null;
    }

    const subItems = (
        [
            portfolioRoutesAvailability.portfolioSummary && {
                title: 'Portfolio Summary',
                testId: 'portfolio-summary-menu-button',
                to: navigate.paths.portfolioSummary(),
                isActive: pathname === '/portfolio' || pathname.startsWith('/portfolio?'),
                isHiddenFromCustomers: isSetToHidden,
            },
            portfolioRoutesAvailability.portfolioSiteExplorer && {
                title: 'Portfolio site explorer',
                testId: 'portfolio-site-explorer-menu-button',
                to: navigate.paths.portfolioSiteExplorer(),
                isActive: pathname.includes('/portfolio/site-explorer'),
                isHiddenFromCustomers: isSetToHidden,
            },
            portfolioRoutesAvailability.speciesRiskIndicators && {
                title: 'Portfolio species risks',
                testId: 'portfolio-species-risks-menu-button',
                to: navigate.paths.portfolioSpeciesRiskIndicators(),
                isActive: pathname.includes('/portfolio/species-risk-indicators'),
                isHiddenFromCustomers: isSetToHidden,
            },
        ] as (NestedSidebarMenuLeafItem | false)[]
    ).filter((item): item is NestedSidebarMenuLeafItem => Boolean(item));

    if (subItems.length === 0) {
        return null;
    }

    const isActive = subItems.some(item => item.isActive);

    return (
        <NestedSidebarMenuItem
            label='Global Nature Performance'
            testId='global-nature-performance-menu-group-button'
            icon={<CircleGauge />}
            isActive={isActive}
            defaultOpen={isActive}
            subItems={subItems}
        />
    );
};

export default GlobalNaturePerformanceMenu;
